import { FC } from 'react'
import ActivateNotificationIntegration, {
  RequiredActivateNotificationIntegration,
} from '@/components/modals/ActivateNotificationIntegration'

interface ActivateVkNotificationCommunityProps {
  open?: boolean
  setOpen?: (open: boolean) => void
  necessarily?: boolean
  integrationId?: number | null
}

const ActivateVkNotificationCommunity: FC<ActivateVkNotificationCommunityProps> = (props) => (
  <ActivateNotificationIntegration provider="vkontakte" {...props} />
)

export const RequiredActivateVkNotificationCommunity: FC = () => (
  <RequiredActivateNotificationIntegration provider="vkontakte" />
)

export default ActivateVkNotificationCommunity
